import { render, staticRenderFns } from "./ExpandableTableSection.vue?vue&type=template&id=ddac2b0e&scoped=true"
import script from "./ExpandableTableSection.vue?vue&type=script&lang=js"
export * from "./ExpandableTableSection.vue?vue&type=script&lang=js"
import style0 from "./ExpandableTableSection.vue?vue&type=style&index=0&id=ddac2b0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac2b0e",
  null
  
)

export default component.exports